import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Body from './components/body';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <div className='App-content'>
          <Routes>
            {/* Main route - supports both query params (?qrCode=xxx) and route params (/qr/:qrCodeId) */}
            <Route path="/" element={<Body />} />
            <Route path="/qr/:qrCodeId" element={<Body />} />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
